import HealthHeartFill from './health-heart-fill.component.js'

export * from './health-heart-fill.component.js'
export default HealthHeartFill

HealthHeartFill.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-heart-fill': HealthHeartFill
  }
}
